import { RootState } from '@atredux/store'

export const getNotificationCount = (state: RootState): number => state.notification.notificationCount
export const getNotificationModalState = (state: RootState): boolean => state.notification.isOpen
export const getNotificationSheetState = (state: RootState): boolean => state.notification.isSheetOpen
